import React from "react";
import { RequestSubscription } from "./request-subscription";
import "./request-metered-subscsription.m.css";

export const RequestMeteredSubsciption = props => (
  <div>
    {/* <MeteredStoryIndicator /> */}
    <RequestSubscription />
  </div>
);
